import * as React from 'react';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { UIDataModel } from '../../../toolkit/uicomponent';
import { MyProfileDetailsComponentProps } from './myprofiledetailscomponent';
import { MyProfileDetailsCSSStyle } from './myprofiledetailscss';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import {MyProfileDetailsComponentState} from './myprofiledetailscomponent';
import {PackStatus} from '../myaccountcomponent';
import './myprofile-details-style.css';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../../popup/confirmrequest/confirmrequestconfirmbuttoncss';
// import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

export class MyProfileDetailsViewImpl extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
        this.subscribe = this.subscribe.bind(this);
        this.unsubscribe = this.unsubscribe.bind(this);
        this.onRewardPointClick = this.onRewardPointClick.bind(this);
    }
    
    draw(props: MyProfileDetailsComponentProps, state: MyProfileDetailsComponentState, cssStyle: MyProfileDetailsCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
       
        console.log("status: " + state.userStatus);
        return (
            <>
              <div id="myprofile-details-wrapper">
                            {
                                this.getWebView(props, state, cssStyle)
                            }
                   </div>
                   <div id="myprofile-details-col-wrapper">
                            {
                                this.getMobileView(props, state, cssStyle)
                            }
                   </div>
            </>
           
        );
    }

    getWebView(props: MyProfileDetailsComponentProps, state: MyProfileDetailsComponentState, cssStyle: MyProfileDetailsCSSStyle)
    {
        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
            <div style={cssStyle.getProfileImageDivCSSStyle()}>
                <img src={this.getContext().getResources().getImage("profile.svg")}/>
                {/* <img width="23px" height="20px" style={{top:"-30px",left:'60px',position:'relative'}} src={this.getContext().getResources().getImage("camera.svg")}/> */}
            </div>
            {/* <div style={cssStyle.getProfileNameDivCSSStyle()}>
                {props.profileName}
            </div>
            */}
            <div style={cssStyle.getProfileStatusDivCSSStyle()}>
                {(state.userStatus === PackStatus.UNSUBSCRIBE || state.userStatus === PackStatus.INPROGRESS) ? this.getContext().getResources().getString(Strings.active_subscriber) : this.getContext().getResources().getString(Strings.inactive_subscriber)} 
            </div>
            {(state.userStatus === PackStatus.INPROGRESS ) &&   <div style={{width:'auto',display:'flex',height:'auto', paddingBottom:'10px',textAlign:'center',lineHeight:'26px',color:'#000000'}}>
         
         <div style={{width:'100%',height:'100%',fontWeight:"initial",fontSize:'19px',paddingRight: "0px"}}>
         {this.getContext().getResources().getString(Strings.in_progress)}
         </div>
     </div>}
            {state.userStatus === PackStatus.UNSUBSCRIBE  && <div style={{width:'auto',display:'flex',height:'auto', paddingBottom:'10px',textAlign:'center',lineHeight:'26px',color:'#000000'}}>
                    {/* <div style={{width:'30%',height:'100%',fontWeight:"bold", fontSize:'19px',}}>
                            {"300K"}
                    </div> */}
                    <div style={{width:'100%',height:'100%',fontWeight:"initial",fontSize:'19px',paddingRight: "0px"}}>
                        {this.getContext().getUserContext().getPackDisplayName()}
                    </div>

            </div>}   
            {(state.userStatus === PackStatus.UNSUBSCRIBE ) &&
         
            <div style={{width:'100%',display:'flex',height:'45px', textAlign:'center',lineHeight:'26px',color:'#000000'}}>
                <div style={{width:'100%',height:'100%',fontWeight:"initial",fontSize:'19px',paddingRight: "0px"}}>
                     <ButtonComponent onClick={this.unsubscribe} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.unsubscribe)}/>
                </div>
            </div>}
        
          {(state.userStatus === PackStatus.SUBSCRIBE ) &&
            <div style={{width:'100%',display:'flex',height:'45px', textAlign:'center',lineHeight:'26px',color:'#000000'}}>
                <div style={{width:'100%',height:'100%',fontWeight:"initial",fontSize:'19px',paddingRight: "0px"}}>
                     <ButtonComponent onClick={this.subscribe} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.subscribe)}/>
                </div>
            </div>}
            <div style={{width:'100%',display:'flex',height:'45px', textAlign:'center',lineHeight:'26px',color:'#000000', marginTop: "10px"}}>
                <div style={{width:'100%',height:'100%',fontWeight:"initial",fontSize:'19px',paddingRight: "0px"}}>
                     <ButtonComponent onClick={this.onRewardPointClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.reward_point_button_label)}/>
                </div>
            </div> 
        </div>
        );
    }


    getMobileView(props: MyProfileDetailsComponentProps, state: MyProfileDetailsComponentState, cssStyle: MyProfileDetailsCSSStyle)
    {
        return (
            <div style={cssStyle.getMobileWrapperCSSStyle()}>
            <div style={cssStyle.getMobileProfileImageDivCSSStyle()}>
                <img src={this.getContext().getResources().getImage("profile.svg")}/>
                {/* <img width="23px" height="20px" style={{top:"-30px",left:'60px',position:'relative'}} src={this.getContext().getResources().getImage("camera.svg")}/> */}
            </div>
            {/* <div style={cssStyle.getProfileNameDivCSSStyle()}>
                {props.profileName}
            </div>
            */}
            <div style={cssStyle.getMobileProfileStatusDivCSSStyle()}>
                {(state.userStatus === PackStatus.UNSUBSCRIBE || state.userStatus === PackStatus.INPROGRESS) ? this.getContext().getResources().getString(Strings.active_subscriber) : this.getContext().getResources().getString(Strings.inactive_subscriber)} 
            </div>
            {(state.userStatus === PackStatus.INPROGRESS ) &&   <div style={{width:'auto',display:'flex',height:'auto', paddingBottom:'10px',textAlign:'center',lineHeight:'26px',color:'#000000'}}>
         
         <div style={{width:'100%',height:'100%',fontWeight:"initial",fontSize:'12px',paddingRight: "0px"}}>
         {this.getContext().getResources().getString(Strings.in_progress)}
         </div>
     </div>}
            {state.userStatus === PackStatus.UNSUBSCRIBE  && <div style={{width:'auto',display:'flex',height:'auto', paddingBottom:'10px',textAlign:'center',lineHeight:'26px',color:'#000000'}}>
                    {/* <div style={{width:'30%',height:'100%',fontWeight:"bold", fontSize:'19px',}}>
                            {"300K"}
                    </div> */}
                    <div style={{width:'100%',height:'100%',fontWeight:"initial",fontSize:'14px',paddingRight: "0px"}}>
                        {this.getContext().getUserContext().getPackDisplayName()}
                    </div>

            </div>}   
            {(state.userStatus === PackStatus.UNSUBSCRIBE ) &&
         
            <div style={{width:'100%',display:'flex',height:'40px', marginLeft: "0px", textAlign:'center',lineHeight:'26px',color:'#000000'}}>
                <div style={{width:'100%',height:'100%',fontWeight:"initial",fontSize:'19px',paddingRight: "0px"}}>
                     <ButtonComponent onClick={this.unsubscribe} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.unsubscribe)}/>
                </div>
            </div>}
        
          {(state.userStatus === PackStatus.SUBSCRIBE ) &&
            <div style={{width:'100%',display:'flex',height:'40px', marginLeft: "0px", textAlign:'center',lineHeight:'26px',color:'#000000'}}>
                <div style={{width:'100%',height:'100%',fontWeight:"initial",fontSize:'19px',paddingRight: "0px"}}>
                     <ButtonComponent onClick={this.subscribe} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.subscribe)}/>
                </div>
            </div>}
            <div style={{width:'100%',display:'flex',height:'40px', marginLeft: "0px", textAlign:'center',lineHeight:'26px',color:'#000000', marginTop: "10px"}}>
                <div style={{width:'100%',height:'100%',fontWeight:"initial",fontSize:'19px',paddingRight: "0px"}}>
                     <ButtonComponent onClick={this.onRewardPointClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.reward_point_button_label)}/>
                </div>
            </div>
        </div>
        );
    }

    private subscribe()
    {
        (this.getUIProps() as MyProfileDetailsComponentProps).subscriber();
    }

    private unsubscribe()
    {
        (this.getUIProps() as MyProfileDetailsComponentProps).unSubscriber();
    }

    private onRewardPointClick()
    {
        (this.getUIProps() as MyProfileDetailsComponentProps).onRewardPointClick();
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/myaccount/myprofiledetails/myprofiledetailsview.tsx